import React, { useEffect } from "react"
import useReportingAndAnalyticsApi from "../../useReportingAndAnalyticsApi";
import useAppStoreContext from "../../../../../shared/context/app-store/app-store.context";
import useLoader from "../../../../../shared/components/loading-dialog/useLoader.hook";
import LoadingDialogComponent from "../../../../../shared/components/loading-dialog/loading-dialog.component";


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Dec/01/2024
 */
export function useGetReportDetailsApi() {

    const { getWizardReportDetails } = useReportingAndAnalyticsApi();
    const { selReportCode, setSelReportDetails } = useAppStoreContext();

    const reportDetailsLoader = useLoader({
        loaderName: "Report Details",
        loadAsync: () =>
            getWizardReportDetails(selReportCode,
                {
                    doIf: () => !!(selReportCode) && reportDetailsLoader.isNotLoading,
                    doBefore: () => {
                        setSelReportDetails(null);
                        reportDetailsLoader.SET_LOADING("Loading Report Details...");
                    },
                    onFulfilled: (data) => {
                        setSelReportDetails(data)
                        reportDetailsLoader.SET_SUCCESS("Success.!");
                    },
                    onException: reportDetailsLoader.SET_EXCEPTION,
                }
            ),
    });


    const ReportDetailsLoadingIndicator = () => {
        return <LoadingDialogComponent loaderHook={reportDetailsLoader} />
    }

    // ---
    return {
        ReportDetailsLoadingIndicator,
        reportDetailsLoader,
    }
}